import { getGraphqlClient } from "@/api/graphql/client.ts";
import { NOTIFICATIONS_PER_PAGE } from "@/api/graphql/notifications/constants.ts";
import { mapNotificationsPageFromGraphQL } from "@/api/graphql/notifications/mappers.ts";
import {
  GetNotificationsByAccountQuery,
  GetNotificationsByUserQuery,
} from "@/api/graphql/notifications/queries.ts";
import {
  createEmptyNotificationsPage,
  GetNotificationsRequest,
  NotificationsPageBO,
} from "@/api/graphql/notifications/types.ts";
import { GetNotificationsByUserQueryQuery } from "@/api/graphql/types/graphql.ts";

const getNotifications = async (
  queryDocument: typeof GetNotificationsByUserQuery,
  { filters, paging, sorts }: GetNotificationsRequest,
): Promise<NotificationsPageBO> => {
  const page = paging?.page || 1;
  const size = paging?.size || NOTIFICATIONS_PER_PAGE;

  const response =
    await getGraphqlClient().request<GetNotificationsByUserQueryQuery>(
      queryDocument,
      {
        request: {
          filters,
          paging: {
            page,
            size,
          },
          sorts,
        },
      },
    );

  return (
    mapNotificationsPageFromGraphQL(
      response.NotificationsMsSearchNotifications,
    ) ?? {
      ...createEmptyNotificationsPage(page, size),
    }
  );
};

export const getNotificationsByUser = async ({
  filters,
  paging,
  sorts,
}: GetNotificationsRequest) =>
  await getNotifications(GetNotificationsByUserQuery, {
    filters,
    paging,
    sorts,
  });

export const getNotificationsByAccount = async ({
  filters,
  paging,
  sorts,
}: GetNotificationsRequest) =>
  await getNotifications(GetNotificationsByAccountQuery, {
    filters,
    paging,
    sorts,
  });
